module.exports = __webpack_public_path__ + "img/user-pos.5710673f.png";